import { EmeshApiClient } from "@/typescript/api_client/emesh_api/client";
import { AxiosResponse } from "axios";
import { getBearerToken } from "@/typescript/lib/common/get_bearer_token";
import {
  GetCompanyResponse,
  GetCompanyErrorResponse
} from "@/typescript/api_client/emesh_api/master/types";

const emeshApiClient: EmeshApiClient = new EmeshApiClient("/v1/company");

export async function getCompanyApi(): Promise<GetCompanyResponse[]> {
  return await emeshApiClient
    .get({
      headers: {
        Authorization: getBearerToken()
      }
    })
    .then((resp: AxiosResponse<GetCompanyResponse[]>) => {
      return Promise.resolve(resp.data as GetCompanyResponse[]);
    })
    .catch(e => {
      if (e.data) return Promise.reject(e.data as GetCompanyErrorResponse);
      return Promise.reject(e);
    });
}
